import React from "react";
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Contact.css"; // Import the custom CSS
import Header from "../../components/header/Header";

const ContactUs = () => {
  return (
    <>
     <Header/>
    <div className="login-container">
      <Container>
        <h2 className="text-center text-white fw-bold mb-4">Contact us</h2>
        <p className="text-center text-white">
          Our users are <span className="fw-bold">very satisfied</span> with our excellent support.
        </p>

        {/* Contact Cards */}
        <Row className="justify-content-center">
          {/* Contact Form Card */}
          <Col md={5} className="mb-3">
            <Card className="glassmorphism text-center">
              <Card.Body>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/561/561127.png"
                  alt="Contact"
                  width="50"
                  className="mb-3"
                />
                <Card.Title className="fw-bold fs-4">Contact Form</Card.Title>
                <Card.Text>
                  Submit your question via our contact form, we usually respond within a day.
                </Card.Text>
                <Button className="btn-custom w-100">Contact us</Button>
                <p className="mt-2 small">RESPONSE WITHIN 1 DAY.</p>
              </Card.Body>
            </Card>
          </Col>

          {/* Cancel Subscription Card */}
          <Col md={5} className="mb-3">
            <Card className="glassmorphism text-center">
              <Card.Body>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/889/889221.png"
                  alt="Cancel Subscription"
                  width="50"
                  className="mb-3"
                />
                <Card.Title className="fw-bold fs-4">Cancel Subscription</Card.Title>
                <Card.Text>
                  Get your subscription cancelled without waiting for our support, using this simple form.
                </Card.Text>
                <Button className="btn-custom w-100">Cancel subscription</Button>
                <p className="mt-2 small">PROCESSED IMMEDIATELY.</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    </>
  );
};

export default ContactUs;
